import { Link } from "wouter";

const SparkIcon = () => (
	<svg className="h-7 w-7 text-amber-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
		<path d="M12 3l1.9 4.1L18 9l-4.1 1.9L12 15l-1.9-4.1L6 9l4.1-1.9L12 3z" />
	</svg>
);

const PaletteIcon = () => (
	<svg className="h-7 w-7 text-amber-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
		<path d="M12 3a9 9 0 0 0 0 18h1.5a1.5 1.5 0 0 0 0-3H12a2.5 2.5 0 0 1 0-5h1a4 4 0 1 0 0-8h-1z" />
		<circle cx="7.5" cy="10" r="1" />
		<circle cx="10" cy="7.5" r="1" />
		<circle cx="14" cy="7.5" r="1" />
	</svg>
);

const ClipboardIcon = () => (
	<svg className="h-7 w-7 text-amber-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
		<rect x="9" y="3" width="6" height="3" rx="1" />
		<path d="M8 4H7a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1" />
	</svg>
);

const Home = () => {
	return (
		<div className="w-full min-h-screen flex items-center justify-center px-4 py-12">
			<div className="max-w-3xl w-full text-center space-y-8">
				{/* Main Heading */}
				<div className="space-y-4">
					<h1 className="text-5xl md:text-7xl font-bold bg-gradient-to-r from-amber-400 via-blue-400 to-amber-400 bg-clip-text text-transparent">
						Metatech Components
					</h1>
					<p className="text-xl md:text-2xl text-amber-300 font-medium">
						Framework-Agnostic Component Library
					</p>
				</div>

				{/* Description */}
				<div className="space-y-3 text-slate-300">
					<p className="text-base md:text-lg leading-relaxed">
						Production-ready, accessible UI components built with HTML and Tailwind CSS. 
						Copy-paste, customize, and use anywhere with no framework lock-in.
					</p>
					<p className="text-sm md:text-base">
						Explore 15+ component types with live previews, code examples, and best practices.
					</p>
				</div>

				{/* Features */}
				<div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-8">
					{[
						{ Icon: SparkIcon, title: "Production Ready", desc: "Battle-tested, accessible components" },
						{ Icon: PaletteIcon, title: "Customizable", desc: "Tailwind CSS for infinite variations" },
						{ Icon: ClipboardIcon, title: "Copy & Paste", desc: "One-click code export with formatting" }
					].map((feature, i) => (
						<div 
							key={i}
							className="p-4 rounded-lg border border-slate-700 bg-slate-800/30 hover:border-amber-500 hover:bg-slate-800/50 transition-all duration-250 flex flex-col items-center text-center"
						>
							<div className="flex items-center justify-center h-12 w-12 mb-3">
								<feature.Icon />
							</div>
							<h3 className="font-semibold mt-0 text-slate-100">{feature.title}</h3>
							<p className="text-xs text-slate-400 mt-1">{feature.desc}</p>
						</div>
					))}
				</div>

				{/* CTA */}
				<div className="flex flex-col sm:flex-row gap-4 justify-center">
					<Link href="/Accordions">
						<a className="px-6 py-3 rounded-lg font-semibold bg-gradient-to-r from-amber-500 to-blue-500 text-white hover:shadow-lg hover:shadow-amber-500/50 transition-all duration-250 inline-block">
							Explore Components
						</a>
					</Link>
					<Link href="/PagesResources">
						<a className="px-6 py-3 rounded-lg font-semibold border border-amber-500 text-amber-400 hover:bg-amber-500/10 transition-all duration-250">
							Learn More
						</a>
					</Link>
				</div>

				{/* Quick Stats */}
				<div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-8 border-t border-slate-700">
					{[
						{ num: "15+", label: "Components" },
						{ num: "100%", label: "Accessible" },
						{ num: "0kb", label: "Runtime JS" },
						{ num: "Tailwind", label: "CSS" }
					].map((stat, i) => (
						<div key={i} className="space-y-1">
							<p className="text-2xl md:text-3xl font-bold text-amber-400">{stat.num}</p>
							<p className="text-xs text-slate-400">{stat.label}</p>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default Home;


